<div class="relative -mt-7">
  <aux-route-tab-group
    [class.site-info]="isSiteInfo"
    [class.px-7]="isFullPage$ | async"
    [tabs]="tabs"
    [indexFn]="indexFn"
    [ignoreFullLayout]="true"
  />
</div>

<router-outlet />
